import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label", "id"]
const _hoisted_2 = {
  class: "modal-content",
  style: {"overflow":"visible"}
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "modal-footer"
}

import {onMounted, ref, useId, useTemplateRef, watch} from "vue";
import {Modal} from "bootstrap";


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationModal',
  props: /*@__PURE__*/_mergeModels({
    showModal: { type: Boolean, default: false },
    title: { default: "" },
    body: {},
    showFooter: { type: Boolean },
    className: {},
    width: { default: "750px" },
    modalBodyContainerClass: { default: "" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss", "submit"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const computedId = useId();
const model = _useModel(__props, "modelValue");
const props = __props;

const modalElement = useTemplateRef<HTMLElement | null>("_modalElement");
const modelObject = ref<Modal>();

const state = ref(false);

onMounted(() => {
    modelObject.value = new Modal(modalElement.value!, {keyboard: false});
});

const emit = __emit;

function handleDismiss() {
    emit("dismiss");
}

function handleSubmit() {
    emit("submit");
}

function _show() {
    state.value = true;
    modelObject.value!.show();
}

function _hide() {
    state.value = false;
    modelObject.value!.hide();
    model.value = false;
    emit("dismiss");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        state.value = showModal as boolean;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

__expose({show: _show});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade overflow-inherit-y", [props.className]]),
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-label": props.title,
    id: _unref(computedId),
    ref: "_modalElement"
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
      style: _normalizeStyle(`max-width: ${props.width}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(props.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (model.value = false), ["prevent"]))
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-body", _ctx.modalBodyContainerClass])
        }, [
          _createElementVNode("p", null, [
            _renderSlot(_ctx.$slots, "body", {
              onDismiss: handleDismiss,
              onSubmit: handleSubmit
            }, () => [
              _createTextVNode(_toDisplayString(props.body), 1)
            ]),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2),
        (props.showFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "footer", {
                onDismiss: handleDismiss,
                onSubmit: handleSubmit
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 10, _hoisted_1))
}
}

})